import script from "./OneClick.vue?vue&type=script&setup=true&lang=js"
export * from "./OneClick.vue?vue&type=script&setup=true&lang=js"

import "./OneClick.vue?vue&type=style&index=0&id=6161f625&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6161f625"]])

export default __exports__